/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
export function isInteractionRequiredError(error) {
    if (error.name !== 'OAuthError') {
        return false;
    }
    const oauthError = error;
    return (oauthError.errorCode === 'interaction_required');
}
export function isAuthorizationCodeError(sdk, error) {
    if (error.name !== 'AuthApiError') {
        return false;
    }
    const authApiError = error;
    // xhr property doesn't seem to match XMLHttpRequest type
    const errorResponse = authApiError.xhr;
    const responseJSON = errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.responseJSON;
    return sdk.options.pkce && ((responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.error) === 'invalid_grant');
}
